import React from "react";

import { faLinkHorizontal, faPencil, faTrashCan } from "@fortawesome/pro-regular-svg-icons";

import IconButton from "../../../../components/Button/IconButton";
// Components
import Icon from "../../../../components/Icon";
import Link from "../../../../components/Link";
import TruncatedText from "../../../../components/Text/TruncatedText";

// styles
import css from "../../CompanyResources.module.scss";
import { LinkRowType } from "../../schema";

const LinkRow = (props: LinkRowType) => {
	return (
		<div data-testid="link-row" className={css.row}>
			<div
				data-testid="link-row-contents-base"
				className={css.clickable}
				onClick={props.incrementCompanyLinkScore}
			>
				<Link href={props.url} isExternal={true}>
					<Icon icon={faLinkHorizontal} size="small" className={css.linkIcon} />
				</Link>
				<Link href={props.url} isExternal={true}>
					<TruncatedText
						maxWidth={500}
						size="paragraph-3"
						weight="light"
						text={props.title ? props.title : props.url}
						className={css.mr8}
					/>
				</Link>
				<Link href={props.url} isExternal={true}>
					<TruncatedText
						maxWidth={500}
						size="paragraph-3"
						weight="light"
						text={props.description}
						className={css.mr8}
					/>
				</Link>
			</div>
			<div className={css.spacer} />
			{props.canManage && (
				<div data-testid="link-row-admin-buttons" className={css.buttonsContainer}>
					<IconButton
						icon={faPencil}
						onClick={props.onSelectEdit}
						className={css.editIcon}
						aria-label="Edit link"
					/>
					<IconButton
						icon={faTrashCan}
						onClick={props.onSelectDelete}
						className={css.deleteIcon}
						aria-label="Delete link"
					/>
				</div>
			)}
		</div>
	);
};

export default LinkRow;
